module.exports = __webpack_public_path__ + "img/vu.d08f3fd7.svg";